import React, { useState, useEffect } from "react";
import Axios from "axios";
import "./../../../../assets/css/purchase/form.css";

// React DateTime
import Datetime from "react-datetime";
import moment from "moment";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import ArModal from "../../../components/Modal/ArModal";
import SoModal from "../../../components/Modal/SoModal";
import Summary from "../../../components/Footer/Summary";
import FormAction from "../../../components/Actions/FormAction";

// Model
import { biMasterModel } from "../../../../model/SellProducts/BiMasterModel";
import { biDetailModel } from "../../../../model/SellProducts/BiDetailModel";

import {
  getData,
  getDataWithComp,
  formatCurrency,
  parseCurrency,
  getAlert,
  getMaxDocNo,
  deleteData,
  randomDelay,
} from "../../../../utils/SamuiUtils";

import {
  formatThaiDateUi,
  formatDateOnChange,
  formatStringDateToDate,
  formatThaiDateUiToDate,
  setCreateDateTime,
  getCreateDateTime,
} from "../../../../utils/DateUtils";

import { InvoiceHandleSubmit } from "../../../../utils/InvoiceUtils";
import { manageWhArPaymentData, setRemarkByPaymentType } from "../../../../utils/PaymentUtils";

const Form = ({ callInitialize, mode, name, docNo, getReport }) => {
  const [formMasterList, setFormMasterList] = useState(biMasterModel());
  const [formDetailList, setFormDetailList] = useState([]);
  const [soDataList, setSoDataList] = useState([]);
  const [arDataList, setArDataList] = useState([]);

  // การแสดงสถานะเอกสาร
  const [statusPaidName, setStatusPaidName] = useState("");
  const [statusPaidColour, setStatusPaidColour] = useState("");

  // การคำนวณเงิน
  const [selectedDiscountValueType, setSelectedDiscountValueType] =
    useState("2");
  const [totalPrice, setTotalPrice] = useState(0);
  const [receiptDiscount, setReceiptDiscount] = useState(0);
  const [subFinal, setSubFinal] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [isVatChecked, setIsVatChecked] = useState(false);
  const [vatAmount, setVatAmount] = useState(0);

  // สำหรับเก็บประเภทการชำระเงิน
  const [paymentType, setPaymentType] = useState(null);
  const [paymentAmount, setPaymentAmount] = useState("full");
  const [specifiedAmount, setSpecifiedAmount] = useState("");
  const [base64Image, setBase64Image] = useState("");

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    const soDataList = await getDataWithComp(
      "API_0701_SO_H",
      `
          AND Doc_Is_INV = 'N' 
          AND Doc_Status_Paid = '2' 
          AND Doc_Status <> '13' 
          AND Doc_Status_Paid_Type = '4' 
          ORDER BY Doc_No DESC
      `
    );
    if (soDataList && soDataList.length > 0) {
      const filteredSoDataList = [];

      for (const soData of soDataList) {
        const filterSoData = await getData("BL_D", `SO_Id = ${soData.Doc_ID}`);
        if (!filterSoData || filterSoData.length === 0) {
          filteredSoDataList.push(soData);
        }
      }

      setSoDataList(filteredSoDataList);
    }

    const arDataList = await getDataWithComp(
      "Tb_Set_AR",
      "ORDER BY AR_Code ASC"
    );
    if (arDataList && arDataList.length > 0) {
      setArDataList(arDataList);
    }

    // สำหรับ View เข้ามาเพื่อแก้ไขข้อมูล
    if (mode === "U") {
      await getModelByNo(arDataList);
    }
  };

  const getModelByNo = async (arDataList) => {
    try {
      const fromDatabase = await getDataWithComp(
        "WT_DocList",
        `AND Doc_No = '${docNo}'`
      );

      if (!fromDatabase || fromDatabase.length === 0) {
        throw new Error("ไม่พบข้อมูลเอกสาร");
      }

      const fromViewAr = arDataList.find(
        (ap) => ap.AR_Id === fromDatabase[0]?.AR_ID
      );

      if (!fromViewAr) {
        throw new Error("ไม่พบข้อมูลลูกค้า");
      }

      setStatusPaidName(fromDatabase[0].DocBLStatusPaid_Name);
      setStatusPaidColour(fromDatabase[0].DocBLStatusPaid_Colour);

      const fromDetail = await getData(
        "API_1302_BL_D",
        `Doc_Id = ${fromDatabase[0]?.Doc_Id}`
      );

      if (!fromDetail || fromDetail.length === 0) {
        throw new Error("ไม่พบข้อมูลรายละเอียดเอกสาร");
      }

      // Additional logic...
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };


  const handleCheckboxChange = (event) => {
    const { name } = event.target;
    setSelectedDiscountValueType(
      selectedDiscountValueType === name ? null : name
    );
  };

  const handleChangeMaster = (e) => {
    const { name, value } = e.target;
    // อัปเดตค่าใน formMasterList
    setFormMasterList((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeDateMaster = (value, name) => {
    // ตรวจสอบว่า value เป็น moment object หรือไม่
    const newValue =
      value && value instanceof moment ? value.format("YYYY-MM-DD") : value;
    // อัปเดตค่าใน formMasterList
    setFormMasterList((prev) => ({
      ...prev,
      [name]: formatDateOnChange(newValue),
    }));
  };

  // SET AR
  const [showArModal, setShowArModal] = useState(false);
  const handleArShow = () => setShowArModal(true);
  const handleArClose = () => setShowArModal(false);
  const onRowSelectAr = (arSelected) => {
    try {
      setFormMasterList({
        ...formMasterList,
        arID: arSelected.AR_Id,
        arCode: arSelected.AR_Code,
        arName: arSelected.AR_Name,
        arAdd1: arSelected.AR_Add1,
        arAdd2: arSelected.AR_Add2,
        arAdd3: arSelected.AR_Add3,
        arProvince: arSelected.AR_Province,
        arZipcode: arSelected.AR_Zipcode,
        arTaxNo: arSelected.AR_TaxNo,
      });

      handleArClose(); // ปิด modal หลังจากเลือก
    } catch (error) {
      getAlert("FAILED", error);
    }
  };


  const [showSoModal, setShowSoModal] = useState(false);
  const handleSoShow = () => setShowSoModal(true);
  const handleSoClose = () => setShowSoModal(false);
  const onRowSelectSo = async (soSelected) => {
    try {
      // ล้างข้อมูลเก่าก่อน
      if (mode === "I") {
        setFormDetailList([]);
      }

      const createNewRow = (index, itemSelected) => {
        let netTotal = parseCurrency(itemSelected.NetTotal) || 0;
        let itemTotal = itemSelected.IsVat === 1 ? netTotal / 1.07 : netTotal;
        let totalVat = itemSelected.IsVat === 1 ? netTotal - itemTotal : 0.0;

        // const itemDiscount = parseCurrency(itemSelected.Item_Discount) || 0;
        // const itemDisType = String(itemSelected.Item_DisType);
        // const totalDiscount = itemDisType === '2' ? (itemDiscount / 100) * itemTotal : itemDiscount;

        // if (itemDisType === '2') {
        //   itemTotal -= (itemDiscount / 100) * itemTotal; // ลดตามเปอร์เซ็นต์
        // } else {
        //   itemTotal -= itemDiscount; // ลดตามจำนวนเงิน
        // }

        // setReceiptDiscount(totalDiscount);

        return {
          ...biDetailModel(index + 1),
          soId: itemSelected.Doc_ID,
          soNo: itemSelected.Doc_No,
          soDocDate: itemSelected.Doc_Date,
          arName: itemSelected.AR_Name,
          remark: itemSelected.Doc_Remark1,
          itemTotal: formatCurrency(itemTotal),
          netTotal: formatCurrency(netTotal),
          totalVat: formatCurrency(totalVat),
        };
      };

      // สร้างรายการใหม่โดยการคำนวณจาก soSelected
      const newFormDetails = soSelected.map((item, index) =>
        createNewRow(formDetailList.length + index, item)
      );

      // เรียงลำดับ newFormDetails โดยใช้ netTotal
      newFormDetails.sort((a, b) => {
        // ใช้ parseCurrency ในการแปลงเป็นตัวเลขเพื่อให้การเรียงลำดับทำงานได้ถูกต้อง
        return (
          parseCurrency(a.netTotal.replace(/[^0-9.-]+/g, "")) -
          parseCurrency(b.netTotal.replace(/[^0-9.-]+/g, ""))
        );
      });

      // อัปเดต formDetailList
      if (mode === "I") {
        setFormDetailList(newFormDetails);
      } else {
        setFormDetailList((prev) => [...prev, ...newFormDetails]);
      }
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  const onConfirmSoSelection = async (soSelected) => {
    try {
      if (!soSelected[0]) {
        getAlert("FAILED", "ท่านยังไม่ได้เลือกใบขายสินค้า");
        return;
      }

      setFormDetailList([]);
      onRowSelectSo(soSelected);
      handleSoClose();

      // แจ้งเตือนผู้ใช้ว่าการเลือกสำเร็จ
      getAlert("OK", "การเลือกใบขายสินค้าสำเร็จ");
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  // const handleVatChange = () => {
  //   setIsVatChecked((prev) => !prev);
  // };

  const handleSubmit = async () => {
    try {
      // ทดสอบหน่วงเวลาก่อนบันทึก (ทดสอบป้องกันการซ้ำของ Doc_No)
      await randomDelay();

      const masterList = await getDataWithComp(
        "API_1301_BL_H",
        `ORDER BY Doc_No DESC`
      );
      let newMaxOd = docNo;

      if (masterList && masterList.length > 0) {
        const maxBi = getMaxDocNo(masterList, "BI");
        newMaxOd = maxBi;
      }

      // ตรวจสอบค่า formMasterList.apID และ formMasterList.apCode
      if (!formMasterList.arID && !formMasterList.arCode) {
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบผู้ขาย");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า apID หรือ apCode
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบรายละเอียดใบขาย");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        comp_id: window.localStorage.getItem("company"),
        doc_no: newMaxOd,
        doc_date: formatStringDateToDate(formMasterList.docDate),
        doc_due_date: formatStringDateToDate(formMasterList.docDueDate),
        doc_status: 1,
        doc_paid_status: 0,
        ar_id: formMasterList.arID,
        created_date: formatThaiDateUiToDate(formMasterList.createdDate),
        created_by_name: window.localStorage.getItem("name"),
        created_by_id: window.localStorage.getItem("emp_id"),
        update_date: null,
        update_by_name: null,
        update_by_id: null,
        cancel_date: null,
        cancel_by_name: null,
        cancel_by_id: null,
        bl_total: totalPrice,
        bl_dis: receiptDiscount,
        bl_is_vat: isVatChecked ? parseCurrency("1") : parseCurrency("2"),
        bl_vat: vatAmount,
        bl_net_total: grandTotal,
        doc_is_inv: parseCurrency("0"),
        doc_inv_no: null,
        doc_is_inv_from: null,
        discount_value: parseCurrency(formMasterList.discountValue || 0.0),
        discount_value_type: parseCurrency(selectedDiscountValueType),
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/create-bi-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      if (response.data.status === "OK") {
        const getDocIdResponse = await Axios.post(
          `${process.env.REACT_APP_API_URL}/api/get-by-doc-no`,
          {
            table: "BL_H",
            doc_no: formMasterData.doc_no,
            comp_id: window.localStorage.getItem("company"),
          },
          {
            headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
          }
        );

        if (getDocIdResponse && getDocIdResponse.data.length > 0) {
          const docId = parseCurrency(getDocIdResponse.data[0].Doc_Id, 10);

          const detailPromises = formDetailList.map(async (item) => {
            const formDetailData = {
              doc_id: docId,
              so_id: item.soId,
            };

            return Axios.post(
              `${process.env.REACT_APP_API_URL}/api/create-bi-d`,
              formDetailData,
              {
                headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
              }
            );
          });

          await Promise.all(detailPromises);
        }

        callInitialize();
        getAlert(response.data.status, response.data.message);
      }
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleUpdate = async () => {
    try {
      // ตรวจสอบค่า formMasterList.apID และ formMasterList.apCode
      if (!formMasterList.arID && !formMasterList.arCode) {
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบผู้ขาย");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า apID หรือ apCode
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบรายละเอียดใบขาย");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        comp_id: formMasterList.compId,
        doc_no: formMasterList.docNo,
        doc_date: formatStringDateToDate(formMasterList.docDate),
        doc_due_date: formatStringDateToDate(formMasterList.docDueDate),
        doc_status: parseCurrency(formMasterList.docStatus, 10),
        doc_paid_status: parseCurrency(formMasterList.docPaidStatus, 10),
        ar_id: formMasterList.arID,
        created_date: formatThaiDateUiToDate(formMasterList.createdDate),
        created_by_name: formMasterList.createdByName,
        created_by_id: formMasterList.createdById,
        update_date: formatThaiDateUiToDate(getCreateDateTime()),
        update_by_name: window.localStorage.getItem("name"),
        update_by_id: window.localStorage.getItem("emp_id"),
        cancel_date: formatThaiDateUiToDate(formMasterList.cancelDate),
        cancel_by_name: formMasterList.cancelByName,
        cancel_by_id: formMasterList.cancelById,
        bl_total: totalPrice,
        bl_dis: receiptDiscount,
        bl_is_vat: isVatChecked ? parseCurrency("1", 10) : parseCurrency("2", 10),
        bl_vat: vatAmount,
        bl_net_total: grandTotal,
        doc_is_inv: parseCurrency("0", 10),
        doc_inv_no: null,
        doc_is_inv_from: null,
        discount_value: parseCurrency(formMasterList.discountValue || 0.0),
        discount_value_type: parseCurrency(selectedDiscountValueType, 10),
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/update-bi-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      if (response.data.status === "OK") {
        // ลบข้อมูลเดิมก่อนจะเริ่มการบันทึกใหม่
        await deleteData(
          "BL_D",
          `WHERE Doc_ID = ${parseCurrency(formMasterList.docId, 10)}`
        );

        const detailPromises = formDetailList.map(async (item) => {
          const formDetailData = {
            doc_id: parseCurrency(formMasterList.docId, 10),
            so_id: item.soId,
          };

          return Axios.post(
            `${process.env.REACT_APP_API_URL}/api/create-bi-d`,
            formDetailData,
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );
        });

        await Promise.all(detailPromises);

        callInitialize();
        getAlert(response.data.status, response.data.message);
      }
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleCancel = async () => {
    try {
      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        doc_no: formMasterList.docNo,
        doc_status: parseCurrency("13", 10),
        cancel_date: formatThaiDateUiToDate(getCreateDateTime()),
        cancel_by_name: window.localStorage.getItem("name"),
        cancel_by_id: window.localStorage.getItem("emp_id"),
        comp_id: window.localStorage.getItem("company"),
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/cancel-bi-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      if (response.data.status === "OK") {
        callInitialize();
        getAlert(response.data.status, response.data.message);
      }
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleTax = async () => {
    try {
      const response = await InvoiceHandleSubmit(
        "BI", // BI = ใบวางบิล, SO = ใบขาย
        formMasterList.arID, // arId
        formMasterList.arCode, // arCode
        formMasterList.arName, // arName
        formMasterList.arTaxNo, // arTaxNo
        formMasterList.arAdd1, // arAdd1
        formMasterList.arAdd2, // arAdd2
        formMasterList.arAdd3, // arAdd3
        formMasterList.arProvince, // arProvince
        formMasterList.arZipcode, // arZipcode
        null, // arContact1
        null, // arContact2
        null, // arTel1
        null, // arTel2
        formMasterList.docDate, // docDate
        formMasterList.docFor, // docFor
        formMasterList.docId, // refDocId
        formMasterList.docNo, // refDoc
        formMasterList.docDate, // refDocDate
        formMasterList.docRemark1, // docRemark1
        isVatChecked // isVat
      );

      callInitialize();
      getAlert(response.data.status, response.data.message);
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const [showPayTypeModal, setShowPayTypeModal] = useState(false);
  const handlePayTypeShow = () => setShowPayTypeModal(true);
  const handlePayTypeClose = () => {
    setShowPayTypeModal(false);

    // รีเซ็ตค่า state ตามต้องการ
    setPaymentType(null);
    setPaymentAmount("full");
    setSpecifiedAmount("");
  };
  const handleUploadSlip = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setBase64Image(reader.result);
        console.log("Base64 Image:", reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // ใช้สำหรับปรับสถานะที่เป็น 'ค้างจ่าย' ให้เป็น 'จ่ายครบ' (เฉพาะเช็ค)
  const handleUpdatePaidStatus = async () => {
    try {
      // ข้อมูลหลักที่จะส่งไปยัง API
      const formUpdateData = {
        doc_paid_status: parseCurrency("2", 10),
        update_date: formatThaiDateUiToDate(getCreateDateTime()),
        update_by_name: window.localStorage.getItem("name"),
        update_by_id: window.localStorage.getItem("emp_id"),
        doc_no: formMasterList.docNo,
        comp_id: window.localStorage.getItem("company"),
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/update-bi-paid-complete`,
        formUpdateData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // ตรวจสอบสถานะการตอบกลับ
      if (response.data.status === "OK") {
        // เอาใบขายที่เก็บอยู่ใน BL_D ไปอัพเดทค่าที่ WH_ARPAYMENT_Onhand & WH_ARPAYMENT_STC
        // for (const formDetail of formDetailList) {
        //   const getSoData = await getDataWithComp(
        //     "API_0701_SO_H",
        //     `AND Doc_No = '${formDetail.soNo}'`
        //   );
        //   if (getSoData && getSoData.length > 0) {
        //     for (const soData of getSoData) {
        //       // ปรับยอดเงินเข้า
        //       await manageWhArPaymentData(
        //         soData.AR_ID, // AR_ID ของลูกค้านั้นๆ
        //         soData.AR_Code, // AR_Code ของสิ่งนั้นๆ
        //         soData.AR_Name, // ชื่อลูกค้าคนนั้นๆ
        //         0, // WarehouseID (Default ไว้ที่ 0 เสมอ)
        //         "AI", // ประเภท เช่น AI/AO
        //         soData.NetTotal, // ค่าจำนวนเงิน
        //         soData.Doc_ID, // ไอดีเอกสาร
        //         soData.Doc_No, // เลขเอกสาร
        //         formMasterList.docNo, // เลขเอกสารอ้างอิง
        //         await setRemarkByPaymentType(parseCurrency(soData.Doc_Status_Paid_Type)), // หมายเหตุ
        //       );
        //     }
        //   }
        // }

        callInitialize();
        getAlert(response.data.status, response.data.message);
      }
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  // การคำนวณยอดรวม (totalPrice)
  useEffect(() => {
    const total = formDetailList.reduce(
      (acc, item) => acc + (parseCurrency(item.netTotal) || 0),
      0
    );
    setTotalPrice(total);
  }, [formDetailList]);

  // การคำนวณส่วนลด (receiptDiscount)
  // useEffect(() => {
  //   let discountValue = parseCurrency(formMasterList.discountValue || 0);
  //   let discountType = String(formMasterList.discountType || '2');
  //   let receiptDiscount = 0;

  //   if (discountType === '2') { // เปอร์เซ็นต์
  //     receiptDiscount = (totalPrice / 100) * discountValue;
  //   } else if (discountType === '1') { // จำนวนเงิน
  //     receiptDiscount = discountValue;
  //   }

  //   setReceiptDiscount(receiptDiscount);
  // }, [totalPrice, formMasterList.discountValue, selectedDiscountValueType]);

  // การคำนวณยอดหลังหักส่วนลด (subFinal)
  useEffect(() => {
    const subFinal = totalPrice - receiptDiscount;
    setSubFinal(subFinal);
  }, [totalPrice, receiptDiscount]);

  // การคำนวณ VAT (vatAmount)
  useEffect(() => {
    const vat = isVatChecked ? subFinal * 0.07 : 0;
    setVatAmount(parseCurrency(vat.toFixed(2)));
  }, [subFinal, isVatChecked]);

  // การคำนวณยอดรวมทั้งสิ้น (grandTotal)
  useEffect(() => {
    const grandTotal = subFinal + vatAmount;
    setGrandTotal(parseCurrency(grandTotal));
  }, [subFinal, vatAmount]);

  return (
    <>
      <Breadcrumbs
        page={docNo}
        isShowStatus={mode === "U"}
        statusName={statusPaidName}
        statusColour={statusPaidColour}
        items={[
          { name: "งานบัญชี", url: "/account" },
          { name: name, url: "/tax" },
          { name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name, url: "#" },
        ]}
        docIsINV={formMasterList.docIsInv}
        onHandleClick={() => getReport("bi1", docNo)}
        onHandleInvoice1={() => getReport("inv1", formMasterList.docInvNo)}
        onHandleInvoice2={() => getReport("inv2", formMasterList.docInvNo)}
        urlImg={formMasterList.docPaidPic}
      />
      <div className="hidden-scrollbar" style={{ maxHeight: "auto", overflowY: "auto" }}>
        <div className="container-fluid my-3">
          <div className="card">
            <div class="container-fluid my-4">
              <h4 className="card-title">ข้อมูลหลัก</h4>
              <div className="row mb-1">
                <div className="col-4">
                  <div className="d-flex">
                    <label>วันที่เอกสาร : </label>
                    <Datetime
                      className="input-spacing-input-date"
                      name="whDocDate"
                      value={formMasterList.docDate || null}
                      onChange={(date) =>
                        handleChangeDateMaster(date, "docDate")
                      }
                      dateFormat="DD-MM-YYYY"
                      timeFormat={false}
                      inputProps={{ readOnly: true, disabled: mode === "U" }}
                    />
                  </div>
                </div>
                <div className="col-4 text-left">
                  <div className="d-flex align-items-center">
                    <label>ลูกค้า</label>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control input-spacing"
                        name="apCode"
                        value={
                          (formMasterList.arCode || "") +
                          " " +
                          (formMasterList.arName || "")
                        }
                        onChange={handleChangeMaster}
                        disabled={true}
                      />
                      <button
                        className="btn btn-outline-secondary"
                        onClick={handleArShow}
                        disabled={mode === "U" ? true : false}
                      >
                        <i className="fas fa-search"></i>
                      </button>
                    </div>
                  </div>
                  <ArModal
                    showArModal={showArModal}
                    handleArClose={handleArClose}
                    arDataList={arDataList}
                    onRowSelectAr={onRowSelectAr}
                  />
                </div>
                <div className="col-4">
                  <div className="d-flex">
                    <label>สร้างโดย : </label>
                    <input
                      type="text"
                      className="form-control input-spacing"
                      value={formMasterList.createdByName}
                      disabled={true}
                    />
                  </div>
                </div>
              </div>
              <div className="row mb-1">
                <div className="col-4">
                  <div className="d-flex">
                    <label>หมายเหตุ : </label>
                    <input
                      type="text"
                      className="form-control input-spacing"
                      name="whDocRemark"
                      value={formMasterList.whDocRemark || ""}
                      onChange={handleChangeMaster}
                      disabled={formMasterList.docIsInv === 1}
                    />
                  </div>
                </div>
                <div className="col-4">
                  <div className="d-flex align-items-center">
                    <label>ที่อยู่</label>
                    <input
                      type="text"
                      className="form-control input-spacing"
                      name="apAdd1"
                      value={formMasterList.arAdd1 || ""}
                      onChange={handleChangeMaster}
                      disabled={true}
                    />
                  </div>
                </div>
                <div className="col-4">
                  <div className="d-flex">
                    <label className="">วันที่สร้าง : </label>
                    <input
                      type="text"
                      className="form-control input-spacing"
                      value={formMasterList.createdDate}
                      disabled={true}
                    />
                  </div>
                </div>
              </div>
              <div className="row mb-1">
                <div className="col-4">
                  {/* <div className="d-flex">
              <label>อ้างอิงเอกสาร : </label>
              <input
                type="text"
                className="form-control input-spacing"
                name="refDoc"
                value={formMasterList.refDoc || ''}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div> */}
                </div>
                <div className="col-4">
                  <div className="d-flex align-items-center">
                    <label></label>
                    <input
                      type="text"
                      className="form-control input-spacing"
                      value={
                        (formMasterList.arAdd2 || "") +
                        " " +
                        (formMasterList.arAdd3 || "")
                      }
                      disabled={true}
                    />
                  </div>
                </div>
              </div>
              <div className="row mb-1">
                <div className="col-4">
                  {/* <div className="d-flex">
              <label>วันที่เอกสารอ้างอิง : </label>
              <input
                //type="date"
                type="text"
                className="form-control input-spacing"
                name="refDocDate"
                value={formMasterList.refDocDate || ''}
                disabled={true}
              />
            </div> */}
                </div>
                <div className="col-4">
                  <div className="d-flex align-items-center">
                    <label></label>
                    <input
                      type="text"
                      className="form-control input-spacing"
                      value={
                        (formMasterList.arProvince || "") +
                        " " +
                        (formMasterList.arZipcode || "")
                      }
                      disabled={true}
                    />
                  </div>
                </div>
              </div>
              <div className="row mb-1">
                <div className="col-4">
                  {/* <div className="d-flex">
              <label>หมายเหตุ : </label>
              <input
                type="text"
                className="form-control input-spacing"
                name="whDocRemark"
                value={formMasterList.whDocRemark || ''}
                onChange={handleChangeMaster}
                disabled={isDisabled} />
            </div> */}
                  {/* <div className="d-flex">
              <label>จากคลัง : </label>
              <select
                class="form-select"
                value={selectedWarehouseFrom}
                onChange={(e) => handleChangeWarehouse(e.target.value, 'FROM')}>
                <option value={null}>
                  กรุณาระบุคลัง
                </option>
                {whFromDataList.map((warehouse) => (
                  <option
                    key={warehouse.WH_Id}
                    value={warehouse.WH_Id}
                  >
                    {warehouse.WH_Name}
                  </option>
                ))}
              </select>
            </div> */}
                </div>
                <div className="col-4">
                  <div className="d-flex align-items-center">
                    <label>เลขที่ภาษี</label>
                    <input
                      type="text"
                      className="form-control input-spacing"
                      value={formMasterList.arTaxNo || ""}
                      disabled={true}
                    />
                  </div>
                </div>
              </div>
              <div className="row mb-1">
                <div className="col-4">
                  {/* <div className="d-flex">
              <label>ไปคลัง :</label>
              <select
                class="form-select"
                value={selectedWarehouseTo}
                onChange={(e) => handleChangeWarehouse(e.target.value, 'TO')}>
                <option value={null}>
                  กรุณาระบุคลัง
                </option>
                {whToDataList.map((warehouse) => (
                  <option
                    key={warehouse.WH_Id}
                    value={warehouse.WH_Id}
                  >
                    {warehouse.WH_Code} ({warehouse.WH_Name})
                  </option>
                ))}
              </select>
            </div> */}
                </div>
                <div className="col-4">
                  {/* <div className="d-flex">
              <label>หมายเหตุ : </label>
              <input
                type="text"
                className="form-control input-spacing"
                name="whDocRemark"
                value={formMasterList.whDocRemark || ''}
                onChange={handleChangeMaster}
                disabled={false} />
            </div> */}
                </div>
              </div>
            </div>
          </div>

          <hr />
        </div>
        <div className="container-fluid my-3">
          <div className="row">
            <div className="col-12">
              <div className="col-12">
                <div className="card">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <div class="container-fluid my-4">
                      <h4 className="card-title">ประเภทเงินที่จ่าย</h4>
                      <div className="row mb-1">
                        <div className="col-4">
                          <div className="d-flex align-items-center">
                            <label>เลขที่ภาษี</label>
                            <input
                              type="text"
                              className="form-control input-spacing"
                              value={formMasterList.arTaxNo || ""}
                              disabled={true}
                            />
                          </div>
                        </div>
                        <div className="col-4">
                          <div className="d-flex align-items-center">
                            <label>เลขที่ภาษี</label>
                            <input
                              type="text"
                              className="form-control input-spacing"
                              value={formMasterList.arTaxNo || ""}
                              disabled={true}
                            />
                          </div>
                        </div>
                        <div className="col-4">
                          <div className="d-flex align-items-center">
                            <label>เลขที่ภาษี</label>
                            <input
                              type="text"
                              className="form-control input-spacing"
                              value={formMasterList.arTaxNo || ""}
                              disabled={true}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mb-1">
                        <div className="col-4">
                          <div className="d-flex align-items-center">
                            <label>เลขที่ภาษี</label>
                            <input
                              type="text"
                              className="form-control input-spacing"
                              value={formMasterList.arTaxNo || ""}
                              disabled={true}
                            />
                          </div>
                        </div>
                        <div className="col-4">
                          <div className="d-flex align-items-center">
                            <label>เลขที่ภาษี</label>
                            <input
                              type="text"
                              className="form-control input-spacing"
                              value={formMasterList.arTaxNo || ""}
                              disabled={true}
                            />
                          </div>
                        </div>
                        <div className="col-4">
                          <div className="d-flex align-items-center">
                            <label>เลขที่ภาษี</label>
                            <input
                              type="text"
                              className="form-control input-spacing"
                              value={formMasterList.arTaxNo || ""}
                              disabled={true}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mb-1">
                        <div className="col-4">
                          <div className="d-flex align-items-center">
                            <label>เลขที่ภาษี</label>
                            <input
                              type="text"
                              className="form-control input-spacing"
                              value={formMasterList.arTaxNo || ""}
                              disabled={true}
                            />
                          </div>
                        </div>
                        <div className="col-4">
                          <div className="d-flex align-items-center">
                            <label>เลขที่ภาษี</label>
                            <input
                              type="text"
                              className="form-control input-spacing"
                              value={formMasterList.arTaxNo || ""}
                              disabled={true}
                            />
                          </div>
                        </div>
                        <div className="col-4">
                          <div className="d-flex align-items-center">
                            <label>เลขที่ภาษี</label>
                            <input
                              type="text"
                              className="form-control input-spacing"
                              value={formMasterList.arTaxNo || ""}
                              disabled={true}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mb-1">
                        <div className="col-4">
                          <div className="d-flex align-items-center">
                            <label>เลขที่ภาษี</label>
                            <input
                              type="text"
                              className="form-control input-spacing"
                              value={formMasterList.arTaxNo || ""}
                              disabled={true}
                            />
                          </div>
                        </div>
                        <div className="col-4">
                          <div className="d-flex align-items-center">
                            <label>เลขที่ภาษี</label>
                            <input
                              type="text"
                              className="form-control input-spacing"
                              value={formMasterList.arTaxNo || ""}
                              disabled={true}
                            />
                          </div>
                        </div>
                        <div className="col-4">
                          <div className="d-flex align-items-center">
                            <label>เลขที่ภาษี</label>
                            <input
                              type="text"
                              className="form-control input-spacing"
                              value={formMasterList.arTaxNo || ""}
                              disabled={true}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-12">
                          <span>รวมเงินที่จ่ายและภาษีที่หักนำส่ง</span>
                          <span
                            style={{ paddingLeft: "10px", color: "#EF6C00" }}
                          >
                            {/* {formatCurrency(soTotal)} */}
                          </span>
                          <span style={{ paddingLeft: "10px" }}>บาท</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <FormAction
        onSubmit={handleSubmit}
        onUpdate={handleUpdate}
        onCancel={handleCancel}
        onApprovedPay={handlePayTypeShow}
        onSubmitTax={handleTax}
        onUpdatePaid={handleUpdatePaidStatus}
        docStatus={formMasterList.docPaidStatus}
        mode={mode}
        disabled={formMasterList.docIsInv === 1 ? true : false}
        disabledInv={formMasterList.docIsInv === 1 ? true : false}
        footer={true}
      />
    </>
  );
};

export default Form;
